var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"toast",class:_vm.toast.type},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"header"},[_c('h3',[_vm._v(_vm._s(_vm.toast.title)+" ")]),_c('button',{on:{"click":_vm.dismissToast}},[_vm._v("X")])]),_c('div',{staticClass:"text"},[_c('p',[_vm._v(_vm._s(_vm.toast.message))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }